/* eslint-disable prettier/prettier */
import { Message } from "../../Utils/Message";
export const Messages = {
    EDITED: new Message("Edited", "Edited")
};
